/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Jump_TitleInputs */

const en_services_jump_title = /** @type {(inputs: Services_Jump_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What we can build together`)
};

const lv_services_jump_title = /** @type {(inputs: Services_Jump_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ko varam izveidot kopā`)
};

/**
* | output |
* | --- |
* | "What we can build together" |
*
* @param {Services_Jump_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_jump_title = /** @type {((inputs?: Services_Jump_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Jump_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_jump_title(inputs)
	return en_services_jump_title(inputs)
});